import { Temporal } from 'temporal-polyfill';

const TIME = /^([01]\d|2[0-3]):([0-5]\d)$/;

export function parseTime(time: string): { hour: number; minute: number } {
  const m = TIME.exec(time);
  if (!m) throw new Error(`Invalid time "${time}", expected HH:MM`);
  return { hour: Number(m[1]), minute: Number(m[2]) };
}

export function date(iso: string): Temporal.PlainDate {
  return Temporal.PlainDate.from(iso);
}

/**
 * The instant a wall-clock time happens on a date in a zone. Times skipped by
 * a daylight-saving change move forward; repeated times take the first one.
 */
export function at(day: Temporal.PlainDate, time: string, timeZone: string): number {
  return day
    .toPlainDateTime(parseTime(time))
    .toZonedDateTime(timeZone, { disambiguation: 'compatible' }).epochMilliseconds;
}

export function atDateTime(dateTime: string, timeZone: string): number {
  return Temporal.PlainDateTime.from(dateTime).toZonedDateTime(timeZone, {
    disambiguation: 'compatible',
  }).epochMilliseconds;
}

export function startOfDay(day: Temporal.PlainDate, timeZone: string): number {
  return day.toZonedDateTime({ timeZone }).epochMilliseconds;
}

export function localDate(ms: number, timeZone: string): Temporal.PlainDate {
  return Temporal.Instant.fromEpochMilliseconds(ms).toZonedDateTimeISO(timeZone).toPlainDate();
}

export function daysBetween(a: Temporal.PlainDate, b: Temporal.PlainDate): number {
  return a.until(b, { largestUnit: 'days' }).days;
}
